import type { DataTableHeader } from 'carbon-components-svelte/src/DataTable/DataTable.svelte';

export const convertToLocalDisplayTime = (date: string) => new Date(date).toLocaleString();

export const asBooleanStatusColumn = {
  sort: (a: boolean, b: boolean) => Number(!!a) - Number(!!b),
};

export const asOptionalTextColumn = {
  display: (val: string | null | undefined) => val ?? '—',
  sort: (a: string | null | undefined, b: string | null | undefined) => (a ?? '').localeCompare(b ?? '') as 0 | 1 | -1,
};

const getRandomId = () => Math.random().toString(36).slice(2);
export const addRandomId = (obj: object) => ({ ...obj, id: getRandomId() });

export const noopSort = () => 0 as const;

type SortEventDetail = { header: DataTableHeader; sortDirection?: 'none' | 'ascending' | 'descending' };

type SortState = { orderBy: string | null; orderDirection: 'ASC' | 'DESC' | null };

/**
 * Handles a DataTable `click:header` sort event. No-ops when `sortDirection` is
 * absent (non-sortable columns). Calls `onSort` with the resolved sort state so
 * callers can assign it in component scope (required for Svelte reactivity).
 *
 * @param event  - The `click:header` CustomEvent dispatched by DataTable.
 * @param onSort - Callback receiving the new sort state to apply.
 */
export const parseSortEvent = (event: CustomEvent<SortEventDetail>, onSort: (sort: SortState) => void): void => {
  const { header, sortDirection } = event.detail;
  if (sortDirection) {
    onSort({
      orderBy: sortDirection === 'none' ? null : header.key,
      orderDirection: sortDirection === 'none' ? null : sortDirection === 'ascending' ? 'ASC' : 'DESC',
    });
  }
};
